module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "申请预览"
    }
  }, [_c('div', {
    staticClass: "view_mian"
  }, [_c('div', {
    staticClass: "title_sty"
  }, [_vm._v("申请人基本信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("申请人姓名：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.formData.RequesterName))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("申请人电话：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.formData.RequesterPhoneNum))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "title_sty"
  }, [_vm._v("待撤文章信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("题目名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.formData.ArticleName))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("作者：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_vm._v(_vm._s(_vm.formData.Author))])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("检测报告单：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.formData.CheckReport[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.formData.CheckReport[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.CheckReport[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.formData.CheckReport[0].FileGuid, 'pdf')
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.formData.CheckReport[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.formData.CheckReport[0].FileGuid,
      "download": "检测报告单",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "info_item",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple info_title"
  }, [_vm._v("待撤文章位置：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light info_con"
  }, [_c('div', {
    ref: 'indexImg_' + _vm.formData.ArticleLocation[0].FileGuid,
    attrs: {
      "id": 'indexImg_' + _vm.formData.ArticleLocation[0].FileGuid
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formData.ArticleLocation[0].FileName))]), _c('a', {
    staticClass: "view_a",
    attrs: {
      "target": "_blank",
      "id": "test"
    },
    on: {
      "click": function($event) {
        return _vm.showImgFn(_vm.formData.ArticleLocation[0].FileGuid)
      }
    }
  }, [_vm._v("查看"), _c('img', {
    attrs: {
      "xss": "removed",
      "data-original": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.formData.ArticleLocation[0].FileGuid
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "download_a",
    attrs: {
      "href": _vm.authImgUrl + '/api/Common/GetOriginalFile?BatchID=' + _vm.formData.ArticleLocation[0].FileGuid,
      "download": "待撤文章位置",
      "title": "下载",
      "target": "_blank"
    }
  }, [_vm._v("\n                            下载\n                            ")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn_box"
  }, [_c('el-button', {
    staticClass: "updata_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updataApply
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
    staticClass: "submit_btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitInfo
    }
  }, [_vm._v("提交")])], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-251dc482"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userPages/applyCancel/viewCancel.vue
// module id = 1181
// module chunks = 1